module.exports = "/lucky-balls/img/infobox/info_Box_000.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_000.png
// module id = 1065
// module chunks = 0